import { vehicleTreeData } from "@/core/apis";

// getter types
export const VEHICLE_TREE_DATA = "vehicleTreeData";

// action types
export const GET_VEHICLE_TREE_DATA = "getVehicleTreeData";

// mutation types
const SET_VEHICLE_TREE_DATA = "setVehicleTreeData";

const state = {
  vehicleTreeData: []
};

const getters = {
  [VEHICLE_TREE_DATA](state) {
    return state.vehicleTreeData;
  }
};

const actions = {
  [GET_VEHICLE_TREE_DATA](context) {
    return new Promise(resolve => {
      vehicleTreeData.getVehiclesTreeData().then(response => {
        context.commit(SET_VEHICLE_TREE_DATA, response.items);
        resolve();
      });
    });
  }
};

const mutations = {
  [SET_VEHICLE_TREE_DATA](state, vehicleTreeData) {
    state.vehicleTreeData = vehicleTreeData;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
